<template>
  <gmap-map
    ref="map"
    :zoom="zoom"
    :center="{lat: place.lat, lng: place.lng}"
    map-type-id="hybrid"
    draggable="true"
    style="height: 300px;"
    @click="updatePointer"
  >
    <gmap-marker
      v-if="place"
      :position="{lat: place.lat, lng: place.lng}"
      :draggable="canUpdatePointer"
      label="★"
      @dragend="updatePointer"
    />
  </gmap-map>
</template>

<script>
  export default {
    name: 'AccessibilityMapComponent',
    props: {
      canUpdatePointer: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        zoom: 3,
        place: {
          lat: 47,
          lng: 3,
        },
      };
    },
    mounted() {
      this.$bus.$once('t-event.get-memo.stored', (memorial) => {
        this.enableMap(memorial);
      });

      const { memorial } = this.get();
      if (memorial) {
        this.enableMap(memorial);
      }
    },
    methods: {
      updatePointer(event) {
        if (this.canUpdatePointer) {
          this.place.lat = event.latLng.lat();
          this.place.lng = event.latLng.lng();
          this.$bus.$emit('t-event.map.update-pointer', this.place);
        }
      },
      enableMap(memorial) {
        if (!_.isNumber(_.get(memorial, 'latitude')) || !_.isNumber(_.get(memorial, 'longitude'))) {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
              this.place.lat = position.coords.latitude;
              this.place.lng = position.coords.longitude;
              this.zoom = 15;
            });
          } else {
            // eslint-disable-next-line no-alert
            alert('Geolocation is not supported by this browser.');
          }
        } else {
          this.place.lat = memorial.latitude;
          this.place.lng = memorial.longitude;
          this.zoom = 15;
        }

        if (this.$refs.map) {
          this.$refs.map.resizePreserveCenter();
        }

        this.$emit('map');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>



// WEBPACK FOOTER //
// src/components/AccessibilityMap.vue